<script>
    export default {
        data() {
            return {
                form_data: {
                    first_name: '',
                    email: '',
                    surname: '',
                    phone_number: '',
                    additional_info: '',
                    languages: '',
                    terms: false,
                    cv: '',
                },
                send: false,
                loading: false,
                succeess_msg: '',
                error_msg: ''
            }
        },
        mounted() {
            console.log('Component mounted.')
        },
        computed: {
            validationErrors(){
                let errors = Object.values(this.errors);
                errors = errors.flat();
                return errors;
            }
        },
        methods: {
            submitForm() {
                
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.loading = true;
                        let formData = new FormData();
                        formData.append('cv', this.form_data.cv)
                        formData.append('first_name', this.form_data.first_name);
                        formData.append('email', this.form_data.email)
                        formData.append('surname', this.form_data.surname)
                        formData.append('phone_number', this.form_data.phone_number)
                        formData.append('additional_info', this.form_data.additional_info)
                        formData.append('languages', this.form_data.languages)
                        axios.post('/emails/send-insider', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                        })
                        .then( response => {
                            this.$ga.event({
                                eventCategory: 'Become Insider Form',
                                eventAction: 'Form send successfully',
                                eventLabel: 'Become Insider Form',
                                eventValue: 1
                            })
                            this.loading = false;
                            this.send = true;
                            this.succeess_msg = response.data

                        })  
                        .catch( e => { 
                            this.loading = false;
                            this.error_msg = "Oops! An error occurred.."
                        });
                    }
                });
            },
            handleFileUpload(){
                this.form_data.cv = this.$refs.cv.files[0];
                console.log(this.form_data.cv);
            }
        }
    }
</script>
